import dayjs from "dayjs";
import { DATE_FORMAT_FOR_SERVER } from "us.collection.economy/constants";
import { ISearchOrders } from "us.collection.economy/interfaces/ClientOrders/IClientOrdersServices";
import {
  COSearchType,
  InitialOrderType
} from "us.collection.economy/components/ClientOrders/Constants";

export function SearchOrders(this: any): ISearchOrders {
  const [startDate, endDate] = this.dateRange ?? [
    dayjs().startOf("month"),
    dayjs().endOf("month"),
  ];

  return {
    startDate: dayjs(startDate).format(DATE_FORMAT_FOR_SERVER),
    endDate: dayjs(endDate).format(DATE_FORMAT_FOR_SERVER),
    manualOrdersOnly: this.manualOrdersOnly,
    searchType: this.orderNo ? COSearchType.ORDER : COSearchType.REG_DATE,
    orderType:
      this.orderType?.length == 0 ||
      this.orderType?.length == this.orderTypes?.length
        ? [InitialOrderType.ALL]
        : this.orderType,
    orderNo: this.orderNo ? Number(this.orderNo) : null,
    customers: this.customers,
    offset: this.offset,
    limit: this.limit,
  };
}
